<template>
    <aside class="pips">
        <!-- Extra one for the Get Started route-->
        <div class="pip" />
        <div v-for="route in routes"
             :key="route.path"
             class="pip"
             :class="{ 'is-active' : isCurrent(route) }"
        />
    </aside>
</template>

<script>
export default {
    name: 'Navigation',

    props: {
        router: {
            required: true
        }
    },

    methods: {
        isCurrent (route) {
            return this.$route.meta.id === route.meta.id
        }
    },

    computed: {
        routes () {
            return this.router.options.routes[0].children
        }
    }
}
</script>
